import { OpenHelpWidgetChatbotParams } from '@wix/wix-chatbot-common/browser';

import { openChatbotPage } from '../../utils/openChatbotPage';
import { openWidget } from './openWidget';

export const openHelpWidgetChatbot = (params: OpenHelpWidgetChatbotParams) => {
  openChatbotPage(params);
  openWidget();
};
